var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotLive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 131,
    viewBox: "0 0 131 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M121.118 30.4944L110.658 40.9544C114.501 48.1299 116.688 56.3265 116.688 65.0238C116.688 79.1342 110.947 91.9347 101.682 101.2L111.795 111.314C123.651 99.457 131 83.0832 131 65.0238C131 52.3582 127.379 40.5306 121.128 30.4944H121.118Z",
    fill: "black",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M102.375 49.2378L93.9088 57.704C94.5156 60.0445 94.8335 62.4909 94.8335 65.0144C94.8335 73.105 91.5395 80.4347 86.2324 85.7417L93.8511 93.3603C101.113 86.0981 105.611 76.0715 105.611 65.0048C105.611 59.4088 104.455 54.0729 102.375 49.2185V49.2378Z",
    fill: "black",
    fillOpacity: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M83.2561 68.366L68.8472 82.7749C76.148 81.4072 81.8884 75.6668 83.2561 68.366Z",
    fill: "black",
    fillOpacity: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M122.813 7.70605H113.278L72.5841 48.3998C70.4073 47.4655 68.0187 46.9454 65.4952 46.9454C55.5168 46.9454 47.4262 55.036 47.4262 65.0143C47.4262 67.5282 47.9463 69.9265 48.8806 72.1032L40.5589 80.425C37.7849 75.9463 36.1668 70.6681 36.1668 65.0143C36.1668 56.9238 39.4609 49.5941 44.7679 44.287L37.1493 36.6684C29.887 43.9307 25.389 53.9572 25.389 65.024C25.389 73.6539 28.134 81.6482 32.7958 88.1977L24.8785 96.1149C18.2616 87.485 14.3126 76.7072 14.3126 65.024C14.3126 50.9136 20.0531 38.1132 29.3187 28.8475L19.2055 18.7343C7.34895 30.5908 0 46.9646 0 65.024C0 80.6561 5.5093 95.0266 14.6883 106.296L8.17727 112.807V122.342H17.7126L122.813 17.2414V7.70605Z",
    fill: "black",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotLive);
export default __webpack_public_path__ + "static/media/notLive.e922938373f3d8ffc4fd5e051cdf2ddc.svg";
export { ForwardRef as ReactComponent };